import { render, staticRenderFns } from "./QuestionsSlide.vue?vue&type=template&id=08225f21"
import script from "./QuestionsSlide.vue?vue&type=script&lang=js"
export * from "./QuestionsSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports